module.exports = __webpack_public_path__ + "img/no_location.d60592d7.svg";